<template>
	<div class="alert" :class="success === true ? 'alert-success' : 'alert-danger'">
	  <div class="row">
	    <div class="col-md-1">
	      <div id="spinner"><i class="fa fa-spinner fa-lg" :class="spin === true ? 'fa-spin' : ''"></i></div>
	    </div>
	    <div class="col-md-8">
	      <p>{{ message }}</p>
	    </div>
	    <div class="col-md-1"></div>
	  </div>
	</div>
</template>

<script>
  export default {
    props: {
      success: Boolean,
      spin: Boolean,
      message: String
    }
  }
</script>

<style scoped>

  #spinner {
      margin-top: -12px;
      transform: translate(0, 50%);
  }

</style>



// WEBPACK FOOTER //
// Feedback.vue?215c92b7